import {
    clearModalContent,
    setModalContent,
} from "src/redux/modules/modalEvent";
import { useDispatch, useSelector } from "react-redux";
import "./MatchScoreModal.scss";
import { changeMatchScoreState } from "src/redux/services/questionnaireServices";
import { fetchQuestionnaireMetaData } from "src/redux/actions/questionnaireActions";
import { useState } from "react";
import Button from "src/components/base/Button/Button";
import { Typography } from "src/latest/src/components";

const MatchScoreModal = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const dispatch = useDispatch();
    const userId = useSelector(
        (state: any) => state?.questionnaireData?.initialMetadata?.user_id
    );

    const startMatchScoreOnboarding = async () => {
        if (userId) {
            setLoading(true);
            await changeMatchScoreState(true, userId);
            await dispatch(fetchQuestionnaireMetaData(true, null, true));
            setLoading(false);
            dispatch(clearModalContent());
        }
    };

    const handleYesClick = () => {
        dispatch(
            setModalContent({
                modalContent: (
                    <>
                        <div className="match-score-modal-second ms-5 me-5">
                            <div className=" font-weight mt-4 text-3">
                                <Typography variant="size-20">
                                    i2iConnect is a platform that provides
                                    clinicians and their clients with tools to
                                    facilitate the provision of care. i2i does
                                    not provide clinical advice, diagnosis or
                                    treatment services.
                                </Typography>
                            </div>
                            <div className="mt-5 text-4">
                                <Typography variant="size-16" color="color-4">
                                    i2i does not recommend specific service
                                    providers. We provide data and insights that
                                    may assist you in making your own decisions.
                                    These insights are based on the experience
                                    of prior users and do not necessarily apply
                                    to you. i2i does not make any guarantees
                                    regarding the recommendations and insights
                                    generated by the platform or the services
                                    provided by users of the platform.
                                </Typography>
                            </div>
                            <div className="mt-5 mb-4 d-flex justify-content-center">
                                <Button
                                    label={"I understand"}
                                    onClick={startMatchScoreOnboarding}
                                    textSize="size-16"
                                    className="modal-container__submit"
                                    isProcessing={loading}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                    </>
                ),
                isWithCancelButton: false,
                size: "lg",
                title: "Calculate Match Score",
                className: "match-score-modal",
            })
        );
    };

    const handleClick = () => {
        dispatch(
            setModalContent({
                modalContent: (
                    <>
                        <div className="match-score-modal ms-5 me-5">
                            <div className="mt-4 text-1">
                                <Typography variant="size-20">
                                    Clinical research has shown that finding a
                                    good match is{" "}
                                    <span className="font-weight-bold">
                                        {" "}
                                        the most important factor
                                    </span>
                                    &nbsp; for successful therapy.
                                </Typography>
                            </div>
                            <div className="mt-5 text-2">
                                <Typography variant="size-20">
                                    Would you like to take a few minutes to tell
                                    us a little more about yourself so we can
                                    help you find a great therapist match?
                                </Typography>
                            </div>
                            <div
                                className="mt-5 mb-4"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                }}
                            >
                                <Button label="Yes" onClick={handleYesClick} />
                                <Button
                                    onClick={() =>
                                        dispatch(clearModalContent())
                                    }
                                    className="ms-5"
                                    style={{ backgroundColor: "white" }}
                                    variant="light"
                                    label="No, thanks"
                                />
                            </div>
                        </div>
                    </>
                ),
                isWithCancelButton: false,
                size: "lg",
                title: "Calculate Match Score",
                className: "match-score-modal ",
            })
        );
    };

    return (
        <Button
            label={"Calculate Your Match Scores"}
            onClick={handleClick}
        />
    );
};

export default MatchScoreModal;
